/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type QuickViewCategoryParagraph_itemSearch = {
    readonly meta: {
        readonly header: string | null;
    } | null;
    readonly pageType: string | null;
    readonly " $refType": "QuickViewCategoryParagraph_itemSearch";
};
export type QuickViewCategoryParagraph_itemSearch$data = QuickViewCategoryParagraph_itemSearch;
export type QuickViewCategoryParagraph_itemSearch$key = {
    readonly " $data"?: QuickViewCategoryParagraph_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"QuickViewCategoryParagraph_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "QuickViewCategoryParagraph_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "meta",
      "storageKey": null,
      "args": null,
      "concreteType": "MetaData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "header",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'eb9af39633fca8139794552abfed63e0';
export default node;
